import { makeAutoObservable, reaction, type IReactionDisposer } from 'mobx'
import { type Contact } from 'entities/Contacts/model/Contact'
import { type ContactsDetailsStore } from 'widgets/ContactsDetails'

export class ContactsGroupCardStore {
  private _currentContact: Contact | null = null
  private _disposeContacts: IReactionDisposer | null = null

  constructor(private _contactsDetailsStore: ContactsDetailsStore) {
    makeAutoObservable(this)

    this.reactionContacts()
  }

  reactionContacts = () => {
    this._disposeContacts?.()
    this._disposeContacts = reaction(
      () => this.contacts.length,
      (length) => {
        if (length === 1) {
          this.handleActiveContact(null)
        }
      },
      {
        fireImmediately: true,
      }
    )
  }

  dispose = () => {
    this._disposeContacts?.()
    this._currentContact = null
  }

  get isCurrentContact() {
    return Boolean(this._currentContact)
  }

  get contacts() {
    return this._contactsDetailsStore.contacts
  }

  get currentContact() {
    return this._currentContact
  }

  handleActiveContact = (item: Contact | null) => {
    this._currentContact = item

    if (item === null) {
      item = this._contactsDetailsStore.contacts[0]
    }

    if (item) {
      this._contactsDetailsStore.setContactId(item.id)
      this._contactsDetailsStore.contactInfoFormStore.syncFields(item.id)
    }
  }
}
